import amapi from '@/api/amapi'

const actions = {
  async enableAutorenew ({ dispatch }, data) {
    try {
      const result = await amapi.makecall('autorenew_enable', data)
      dispatch('reportSuccess', result.resultmsg)
      dispatch('getServices')
      return result
    } catch (e) {
      dispatch('reportError', e)
    }
  }
}

export default {
  actions
}
